import React from 'react';

// Consistent business information for all schema
const businessInfo = {
  name: "BuildPilot",
  legalName: "GSTUDIO Pty Ltd",
  url: "https://buildpilot.com.au",
  logo: "https://buildpilot.com.au/images/buildpilot-logo.png",
  image: "https://buildpilot.com.au/images/buildpilot-og.jpg",
  telephone: "1300 885 919",
  email: "hello@buildpilot.com.au",
  address: {
    streetAddress: "Adelaide",
    addressLocality: "Adelaide",
    addressRegion: "SA",
    postalCode: "5000",
    addressCountry: "AU"
  },
  geo: {
    latitude: -34.9285,
    longitude: 138.6007
  },
  priceRange: "$$",
  openingHours: "Mo-Fr 08:00-18:00",
  sameAs: [
    // Kept in sync with the canonical list in SiteSchema.jsx.
    "https://www.facebook.com/buildpilot.com.au",
    "https://instagram.com/buildpilot.com.au",
    "https://www.linkedin.com/company/buildpilotau/",
    "https://www.tiktok.com/@buildpilot.com.au",
    "https://apps.apple.com/au/app/buildpilot/id6477372083",
    "https://play.google.com/store/apps/details?id=com.buildpilot.android",
    "https://www.wikidata.org/wiki/Q140478516"
  ],
  areaServed: [
    "Adelaide",
    "Adelaide Hills",
    "Northern Adelaide",
    "Southern Adelaide",
    "Western Adelaide",
    "South Australia"
  ]
};

// LocalBusiness Schema - now handled site-wide by OrganizationSchema in App.js
// This component is kept as a no-op for backwards compatibility with existing page imports
export const LocalBusinessSchema = () => null;

// Review/Testimonial Schema (DEPRECATED - no-op)
//
// 2026-02 removal: this component previously emitted a hard-coded array
// of five invented testimonials ("Sarah M.", "James T.", "Michelle K.",
// "David & Lisa R.", "Tom H.") as JSON-LD Review markup. That violates
// Google's structured-data policy (self-serving, unverifiable reviews)
// and our own legal/compliance directive. The component is retained as
// a no-op purely so that existing `<ReviewSchema />` and
// `<PageSEO includeReviews />` imports across ~6 pages keep compiling.
// If BuildPilot later wires in verified customer testimonials from a
// review-provider (Product Review, Trustpilot etc), replace this with a
// component that maps *actual* verified review data - never invent.
export const ReviewSchema = () => null;

// Breadcrumb Schema Generator
export const BreadcrumbSchema = ({ items }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
};

// Service Schema for service pages
export const ServiceSchema = ({ serviceName, description, url }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": serviceName,
    "provider": {
      "@type": "LocalBusiness",
      "name": businessInfo.name,
      "url": businessInfo.url
    },
    "areaServed": {
      "@type": "City",
      "name": "Adelaide"
    },
    "description": description,
    "url": url
  };

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
};

// Website Schema - now handled site-wide by OrganizationSchema in App.js
export const WebsiteSchema = () => null;

// Combined Schema Component for easy use on all pages
export const SEOSchemas = ({ 
  includeLocalBusiness = true,
  includeReviews = false, // deprecated - kept for prop-compat, always no-op
  includeWebsite = false,
  breadcrumbs = null,
  // eslint-disable-next-line no-unused-vars
  reviews = null // deprecated - review data is never emitted; see ReviewSchema
}) => {
  return (
    <>
      {includeLocalBusiness && <LocalBusinessSchema />}
      {includeReviews && <ReviewSchema />}
      {includeWebsite && <WebsiteSchema />}
      {breadcrumbs && <BreadcrumbSchema items={breadcrumbs} />}
    </>
  );
};

export default SEOSchemas;
